/* eslint no-param-reassign: "error" */
import {
  createSlice,
} from '@reduxjs/toolkit';

import type { PublicApiSettingsJson } from './service/entity/publicApiSettingsEntity';
import type {
  PayloadAction,
} from '@reduxjs/toolkit';

/**
 * 支払ステート
 */
export type PaymentStateType = {
  /** 選択施設ID */
  selectedNurseryId: string | null,
  /** API設定 */
  apiSettings: { [key: string]: PublicApiSettingsJson } | null,
}

const initialState: PaymentStateType = {
  selectedNurseryId: null,
  apiSettings: null,
};

/**
 * 支払Slice
 */
export const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    /** 選択施設IDをセット */
    setSelectedNurseryId:
      (state, action: PayloadAction<string | null>) => {
        state.selectedNurseryId = action.payload;
      },
    /** API設定をセット */
    setApiSettings:
      (state, action: PayloadAction<{ [key: string]: PublicApiSettingsJson }>) => {
        state.apiSettings = action.payload;
      },
  },
});
